export const SUBSCRIPTION_FEATURE_KEYS = {
  workspaceDirectory: "workspaceDirectory",
  workspaceCreate: "workspaceCreate",
  workspaceDetails: "workspaceDetails",
  billing: "billing",
  residents: "residents",
  medicationManagement: "medicationManagement",
  emergencyEvacuationDrills: "emergencyEvacuationDrills",
  waterTemperatureReadings: "waterTemperatureReadings",
  bedroomsUsableSpace: "bedroomsUsableSpace",
  annualLicenseFee: "annualLicenseFee",
  fireExtinguishers: "fireExtinguishers",
  smokeAlarms: "smokeAlarms",
  heatingAppliances: "heatingAppliances",
  windows: "windows",
  doorsAbilityToOpen: "doorsAbilityToOpen",
  staffDirectory: "staffDirectory",
  assessments: "assessments",
  carePlans: "carePlans",
  schedules: "schedules",
  attendance: "attendance",
  timesheets: "timesheets",
  documents: "documents",
  hiring: "hiring",
  website: "website",
  chatInbox: "chatInbox",
  reports: "reports",
  ai: "ai",
  payroll: "payroll",
  hipaaAfhManagement: "hipaaAfhManagement",
  wac38876ComplianceSupport: "wac38876ComplianceSupport",
  emar: "emar",
  adlTrackingTaskManagement: "adlTrackingTaskManagement",
  oneClickNegotiatedCarePlanGeneration: "oneClickNegotiatedCarePlanGeneration",
  automaticAdlTaskGeneration: "automaticAdlTaskGeneration",
  cbhsSupportiveSupervisionTracking: "cbhsSupportiveSupervisionTracking",
  automaticCbhsMonthlyReportGeneration: "automaticCbhsMonthlyReportGeneration",
  smartDailyProgressNotes: "smartDailyProgressNotes",
  complianceDashboard: "complianceDashboard",
  complianceAlerts: "complianceAlerts",
  incidentReporting: "incidentReporting",
  automatedComplianceBundleCreation: "automatedComplianceBundleCreation",
  residentDocumentManagement: "residentDocumentManagement",
  residentDocumentElectronicSignatures: "residentDocumentElectronicSignatures",
  rnDelegationWorkflows: "rnDelegationWorkflows",
  rnDelegationElectronicSignatures: "rnDelegationElectronicSignatures",
  familyPortal: "familyPortal",
  familyPortalElectronicSignatures: "familyPortalElectronicSignatures",
  secureCareTeamFaxExchange: "secureCareTeamFaxExchange",
  secureCareTeamDocumentExchange: "secureCareTeamDocumentExchange",
  calendarManagement: "calendarManagement",
  mealPlanning: "mealPlanning",
  activityPlanning: "activityPlanning",
  shiftManagement: "shiftManagement",
  automaticRegularTimeCalculation: "automaticRegularTimeCalculation",
  automaticOvertimeCalculation: "automaticOvertimeCalculation",
  weeklyCaregiverHoursTracking: "weeklyCaregiverHoursTracking",
  monthlyCaregiverHoursTracking: "monthlyCaregiverHoursTracking",
  automaticHoursReports: "automaticHoursReports",
  caregiverHoursReportFiltering: "caregiverHoursReportFiltering",
  timesheetCorrectionWorkflows: "timesheetCorrectionWorkflows",
  shiftDisputeResolutionWorkflows: "shiftDisputeResolutionWorkflows",
};

export const OCARE_FEATURE_CATALOG = [
  {
    key: SUBSCRIPTION_FEATURE_KEYS.hipaaAfhManagement,
    label: "HIPAA-compliant AFH management",
    group: "Compliance",
    tier: "FREE",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.wac38876ComplianceSupport,
    label: "WAC 388-76 compliance support",
    group: "Compliance",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.waterTemperatureReadings,
    label: "Hot water temperature monitoring",
    group: "Compliance",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.emar,
    label: "eMAR",
    group: "Medication",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.adlTrackingTaskManagement,
    label: "ADL tracking and task management",
    group: "Care Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.oneClickNegotiatedCarePlanGeneration,
    label: "1-click Negotiated Care Plan generation",
    group: "Care Plans",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.automaticAdlTaskGeneration,
    label: "Automatic ADL task generation",
    group: "Care Operations",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.cbhsSupportiveSupervisionTracking,
    label: "CBHS supportive supervision tracking",
    group: "CBHS",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.automaticCbhsMonthlyReportGeneration,
    label: "Automatic CBHS monthly report generation",
    group: "CBHS",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.smartDailyProgressNotes,
    label: "Smart daily progress notes",
    group: "Daily Notes",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.complianceDashboard,
    label: "Compliance dashboard",
    group: "Compliance",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.complianceAlerts,
    label: "Compliance alerts",
    group: "Compliance",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.incidentReporting,
    label: "Incident reporting",
    group: "Compliance",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.automatedComplianceBundleCreation,
    label: "Automated compliance bundle creation",
    group: "Compliance",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.residentDocumentManagement,
    label: "Resident document management",
    group: "Documents",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.residentDocumentElectronicSignatures,
    label: "Electronic signatures for resident documents",
    group: "Documents",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.rnDelegationWorkflows,
    label: "RN delegation workflows",
    group: "Medication",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.rnDelegationElectronicSignatures,
    label: "E-signatures for RN delegation",
    group: "Medication",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.familyPortal,
    label: "Family portal",
    group: "Family",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.familyPortalElectronicSignatures,
    label: "Family portal e-signature support",
    group: "Family",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.secureCareTeamFaxExchange,
    label: "Secure care-team fax exchange",
    group: "Communication",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.secureCareTeamDocumentExchange,
    label: "Secure care-team email/document exchange",
    group: "Communication",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.calendarManagement,
    label: "Calendar management",
    group: "Care Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.mealPlanning,
    label: "Meal planning",
    group: "Care Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.activityPlanning,
    label: "Activity planning",
    group: "Care Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.shiftManagement,
    label: "Shift management",
    group: "Staff Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.automaticRegularTimeCalculation,
    label: "Automatic regular-time calculation",
    group: "Staff Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.automaticOvertimeCalculation,
    label: "Automatic overtime calculation",
    group: "Staff Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.weeklyCaregiverHoursTracking,
    label: "Weekly caregiver-hours tracking",
    group: "Staff Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.monthlyCaregiverHoursTracking,
    label: "Monthly caregiver-hours tracking",
    group: "Staff Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.automaticHoursReports,
    label: "Automatic hours reports",
    group: "Staff Operations",
    tier: "PREMIUM",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.caregiverHoursReportFiltering,
    label: "Caregiver-based filtering for hours/reports",
    group: "Staff Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.timesheetCorrectionWorkflows,
    label: "Timesheet correction workflows",
    group: "Staff Operations",
    tier: "STANDARD",
  },
  {
    key: SUBSCRIPTION_FEATURE_KEYS.shiftDisputeResolutionWorkflows,
    label: "Shift dispute resolution workflows",
    group: "Staff Operations",
    tier: "PREMIUM",
  },
];

export const OCARE_STANDARD_SUBSCRIPTION_FEATURES = [
  "Enhanced HIPAA-compliant AFH tools",
  "eMAR medication management and administration",
  "MCO and smart daily notes with reporting",
  "1-click Negotiated Care Plan generation",
  "Resident Care Processes and care plans",
  "Staff scheduling, timesheets, and hours tracking",
  "Compliance dashboard and alerts",
  "Incident reporting and follow-up",
  "Staff and resident clock-in/clock-out",
  "Secure eFax sending and receiving",
  "All pharmacies and healthcare providers fax integration",
  "Annual subscription includes a professional AFH website",
];

export const OCARE_FREE_SUBSCRIPTION_FEATURES = [
  "Workspace, organization, and facility profile management",
  "Basic resident and care staff directory",
  "Basic care operations setup",
  "Wallet, charges, payment methods, and subscription management",
  "Limited HIPAA-compliant AFH tools",
  "Caregiver Finder",
  "Home-maintenance professional finder",
];

export const OCARE_PREMIUM_SUBSCRIPTION_FEATURES = [
  "Everything in Standard",
  "Payroll, caregiver payments, and reporting",
  "Ova",
  "Annual Premium includes supported onboarding and content migration from another AFH system",
];

export const oCareSubscriptionFeatureLabels = (tier) => {
  const normalizedTier = String(tier || "").toUpperCase();
  if (normalizedTier === "PREMIUM") return OCARE_PREMIUM_SUBSCRIPTION_FEATURES;
  if (normalizedTier === "STANDARD") return OCARE_STANDARD_SUBSCRIPTION_FEATURES;
  return OCARE_FREE_SUBSCRIPTION_FEATURES;
};

const tierRank = { FREE: 0, STANDARD: 1, PREMIUM: 2 };
const oCareFeaturesForTier = (tier) => {
  const rank = tierRank[tier] ?? 0;
  return OCARE_FEATURE_CATALOG.filter(
    (feature) => (tierRank[feature.tier] ?? 0) <= rank,
  ).map((feature) => feature.key);
};

export const oCarePlanFeatureLabels = (tier) => {
  const rank = tierRank[tier] ?? 0;
  return OCARE_FEATURE_CATALOG.filter(
    (feature) => (tierRank[feature.tier] ?? 0) <= rank,
  ).map((feature) => feature.label);
};

const planSignal = (subscription = {}, workspace = {}) =>
  [
    subscription?.code,
    subscription?.name,
    subscription?.tier,
    subscription?.planCode,
    subscription?.planName,
    subscription?.subscriptionPlanCode,
    subscription?.subscriptionPlanName,
    subscription?.plan?.code,
    subscription?.plan?.name,
    subscription?.plan?.tier,
    subscription?.subscriptionPlan?.code,
    subscription?.subscriptionPlan?.name,
    subscription?.subscriptionPlan?.tier,
    workspace?.planCode,
    workspace?.planName,
    workspace?.subscriptionPlanCode,
    workspace?.subscriptionPlanName,
    workspace?.subscriptionPlan?.code,
    workspace?.subscriptionPlan?.name,
    workspace?.subscriptionPlan?.tier,
    workspace?.currentSubscription?.subscriptionPlanCode,
    workspace?.currentSubscription?.subscriptionPlanName,
    workspace?.currentSubscription?.plan?.code,
    workspace?.currentSubscription?.plan?.name,
    workspace?.activeSubscription?.subscriptionPlanCode,
    workspace?.activeSubscription?.subscriptionPlanName,
    workspace?.activeSubscription?.plan?.code,
    workspace?.activeSubscription?.plan?.name,
    workspace?.subscription?.subscriptionPlanCode,
    workspace?.subscription?.subscriptionPlanName,
    workspace?.subscription?.plan?.code,
    workspace?.subscription?.plan?.name,
    workspace?.subscription?.subscriptionPlan?.code,
    workspace?.subscription?.subscriptionPlan?.name,
    workspace?.subscription?.subscriptionPlan?.tier,
  ]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .join(" ")
    .toUpperCase();

export const subscriptionTier = (subscription = {}, workspace = {}) => {
  const signal = planSignal(subscription, workspace);
  if (signal.includes("PREMIUM") || signal.includes("PRO")) return "PREMIUM";
  if (signal.includes("STANDARD") || signal.includes("PLUS")) return "STANDARD";
  if (signal.includes("FREE") || signal.includes("BASIC")) return "FREE";
  return "FREE";
};

const featureSet = (features) =>
  features.reduce((acc, feature) => ({ ...acc, [feature]: true }), {});

export const subscriptionFeaturesFor = (subscription = {}, workspace = {}) => {
  const keys = SUBSCRIPTION_FEATURE_KEYS;
  const tier = subscriptionTier(subscription, workspace);
  const baseFeatures = [
    keys.workspaceDirectory,
    keys.workspaceCreate,
    keys.workspaceDetails,
    keys.billing,
    keys.residents,
    keys.staffDirectory,
    ...oCareFeaturesForTier("FREE"),
  ];
  const standardFeatures = [
    keys.medicationManagement,
    keys.emergencyEvacuationDrills,
    keys.waterTemperatureReadings,
    keys.bedroomsUsableSpace,
    keys.annualLicenseFee,
    keys.fireExtinguishers,
    keys.smokeAlarms,
    keys.heatingAppliances,
    keys.windows,
    keys.doorsAbilityToOpen,
    keys.assessments,
    keys.carePlans,
    keys.schedules,
    keys.attendance,
    keys.timesheets,
    keys.documents,
    keys.hiring,
    keys.website,
    ...oCareFeaturesForTier("STANDARD"),
  ];
  const premiumFeatures = [
    keys.chatInbox,
    keys.reports,
    keys.ai,
    keys.payroll,
    ...oCareFeaturesForTier("PREMIUM"),
  ];

  if (tier === "PREMIUM")
    return featureSet([
      ...baseFeatures,
      ...standardFeatures,
      ...premiumFeatures,
    ]);
  if (tier === "STANDARD")
    return featureSet([...baseFeatures, ...standardFeatures]);
  return featureSet(baseFeatures);
};

export const hasSubscriptionFeature = (features = {}, key) =>
  Boolean(features?.[key]);
